import React, { useState } from 'react';
import DropDownHeader from 'design-v2/common/DropDownHeader';
import BCComponentWrapper from 'design-v2/common/BCComponentWrapper/BCComponentWrapper';
import { Radio, Typography } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import { blockoutTypeEnums, IBlockoutProps } from 'app/common/BlockoutsByService/types';
import ViewQuiltOutlinedIcon from '@material-ui/icons/ViewQuiltOutlined';
import IconsService from 'external-services/icons-service/icons.service';
import { IconTypes } from 'external-services/icons-service/icons.types';
export const ListItem = (props: any) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px',
      marginBottom: '10px',
      borderBottom: '1px solid #E0E0E0',
      border: '2px solid #EEEEEE',
      borderRadius: '5px',
      borderColor: props.checked ? '#A91264' : '#EEEEEE',
      cursor: 'pointer',
    }}
    onClick={props.onClick}
    >
      <Radio style={{
        padding: '0',
        marginRight: '15px',
        width: '20px',
      }}
      color={'primary'}
      checked={props.checked}
      />
      <div style={{
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        height: '54px',
        justifyContent: 'space-between',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '5px',
        }}>
          {props.icon}
          <Typography style={{
            marginLeft: '10px',
            fontWeight: '700',
            fontSize: '16px',
            lineHeight: '18px',
          }}>{props.title}</Typography>
        </div>
        <Typography
          style={{
            fontSize: '16px',
            lineHeight: '18px',
          }}
        >{props.description}</Typography>
      </div>
    </div>
  );

}
const Blockout = (props: IBlockoutProps) => {
  // change to Enum if list has multi options in the future
  const [blockoutType, setBlockoutType] = useState<blockoutTypeEnums>(null);

  //ts-ignore
  const TableIcon = IconsService.getIcon(IconTypes.table);
  const handleSave = () => {
    props.handleSaveClick(blockoutType);
  }
  const handleClick = (value: blockoutTypeEnums) => {
    setBlockoutType(value)
  }

  return (
    <BCComponentWrapper containerStyle={{
      width: '580px',
    }}>
      <DropDownHeader title="Create blockout"
                      saveText={'Next'} handleCancel={props.handleModalClose}
                      handleSave={handleSave}
      />
      <div>
        <div style={{
          margin: '24px 0',
        }}>
          <Typography style={{
            fontSize: '16px',
          }}>{`Use a Blockout to block online reservations for a specified time period.`}</Typography>
          <Typography style={{
            fontSize: '16px',
          }}>{`Blockouts may be by table, section, service or all day.`}</Typography>
        </div>

        <div>
          {!props.showBlockoutOnFp &&<ListItem checked={blockoutType === blockoutTypeEnums.byTableAndSection} icon={<AccessTimeIcon/>}
                    title={'Blockout by table or section'}
                    description={'Use checkboxes to specify which tables and times to block out'}
                    onClick={() => handleClick(blockoutTypeEnums.byTableAndSection)}
          />}
          {props.showBlockoutOnFp &&<ListItem checked={blockoutType === blockoutTypeEnums.byTable} icon={<div style={{width: 25, height: 25}}><TableIcon/></div>}
                    title={'Blockout by table'}
                    description={'Select tables and times to block out'}
                    onClick={() => handleClick(blockoutTypeEnums.byTable)}
          />}

          {props.showBlockoutOnFp &&<ListItem checked={blockoutType === blockoutTypeEnums.bySection} icon={<ViewQuiltOutlinedIcon/>}
                    title={'Blockout by section'}
                    description={'Select a section to block out for the day'}
                    onClick={() => handleClick(blockoutTypeEnums.bySection)}
          />}

          <ListItem checked={blockoutType === blockoutTypeEnums.byService} icon={<RestaurantIcon/>}
                    title={'Blockout by service'}
                    description={'Block out all tables for a particular service'}
                    onClick={() => handleClick(blockoutTypeEnums.byService)}
          />
        </div>
      </div>
    </BCComponentWrapper>
  );
}

export default Blockout;
